// extracted by mini-css-extract-plugin
module.exports = {"globalErrorContainer":"ErrorBoundary_globalErrorContainer__1sPMS"};